<!--  支付抢购 -->
<template>
    <div class="container">
        <div class="bd1 flex-col">
            <div class="layer2 flex-row">
                <img class="label1" referrerpolicy="no-referrer" src="@a/other/icon1.png" />
                <span class="word2">星球门票退款验证</span>
                <img class="label2" referrerpolicy="no-referrer" src="@a/other/icon2.png" />
            </div>
            <div class="layer3 flex-col">
                <div class="wrap2 flex-row">
                    <input type="tel" class="info3" placeholder="请输入手机号" v-model="phone">
                    <span class="info4" @click="getCodeHandle">{{codeText}}</span>
                </div>
            </div>
            <div class="layer4 flex-col"><input type="number" class="word3" placeholder="请输入验证码" v-model="code"></div>
            <div class="layer5 flex-col" @click="validate"><span class="word4">验证</span></div>
            <span class="word5">验证成功后，退款会以红包的形式发出</span>
        </div>
    </div>
</template>
<script>
import { zsxq_check, zsxq_submit } from "@/api/other";
import { send_sms, check_sms } from "@/api/xuandui_gadgets";
import { phoneValidation, events } from "@/utils/validation";
export default {
    data() {
        return {
            phone: '',
            code: '',
            code: null,
            codeText: '获取验证码',
            time: 60,
            canClick: true,
            sms_info: {
                phone: '',
                sms_id: '',
            }
        }
    },
    created() {
        document.title = '星球门票退款验证';

        zsxq_check()
        .then(data=>{
            if (data.code == 10002) {
                this.$toast(data.data.msg);
                return;
            }
        });
    },
    methods: {
        getCodeHandle() {
            if (!this.canClick) {
                return;
            }

            // 验证手机号是否正确
            if (!phoneValidation(this.phone)) {
                this.$toast('请输入正确的手机号');
                return;
            }

            send_sms({ mobile: this.phone }).then(res => {
                if (res.error > 0) {
                    if (res.msg) {
                        this.$toast(res.msg);
                    }
                    return;
                }

                this.sms_info.phone = this.phone;
                this.sms_info.sms_id = res.sms_id;

                // 倒计时
                events(this.codeText, this.time, this.canClick, (codeText, time, canClick) => {
                    this.codeText = codeText;
                    this.time = time;
                    this.canClick = canClick;
                });
            }).catch(msg => {
                this.$toast(msg || '请求失败');
            });
        },
        validate() {
            if (!this.phone) {
                this.$toast('请输入手机号');
                return;
            }
            if (!phoneValidation(this.phone)) {
                this.$toast('请输入正确的手机号');
                return;
            }
            if (!this.code) {
                this.$toast('请输入验证码');
                return;
            }

            check_sms({ sms_id: this.sms_info.sms_id, code: this.code }).then(res => {
                if (res.error > 0) {
                    return Promise.reject(res.msg);
                }
                if (this.sms_info.phone != this.phone) {
                    return Promise.reject('请重新验证');
                }
                this.do_submit();
            }).catch(msg => {
                this.$toast(msg || '请求失败');
            });

        },
        do_submit() {
            zsxq_submit({phone: this.phone})
            .then(data=>{
                if (data.code == 10002) {
                    this.$toast(data.data.msg);
                    return;
                }
                // this.$toast('返现成功，请返回聊天列表查收红包提醒');
                this.$dialog.alert({
                    title: '',
                    showConfirmButton: true,
                    message: '返现成功，请返回聊天列表查收红包提醒'
                });

                this.phone = '';
                this.code = '';
            })
        },
    },
}
</script>
<style lang="scss">
.flex-col {
    display: flex;
    flex-direction: column;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.container {
    width: 100%;
    height: 100%;
    background-color: #fff;
}

.bd1 {
    z-index: auto;
    width: 600px;
    height: auto;
    margin: 0 auto;
    padding-top: 200px;

    input {
        border: 0;
        text-align: left !important;
        color: #333 !important;

        &::placeholder {
            color: #ccc;
        }
    }

    .layer2 {
        z-index: auto;
        width: 512px;
        height: 66px;
        margin-left: 46px;
        justify-content: space-between;

        .label1 {
            z-index: 41;
            width: 48px;
            height: 48px;
            margin-top: 10px;
        }

        .word2 {
            z-index: 49;
            width: 384px;
            height: 66px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 48px;
            font-family: PingFangSC-Semibold;
            white-space: nowrap;
            line-height: 66px;
            text-align: center;
        }

        .label2 {
            z-index: 45;
            width: 48px;
            height: 48px;
            margin-top: 10px;
        }
    }

    .layer3 {
        z-index: 56;
        height: 88px;
        border-radius: 44px;
        border: 2px solid rgba(226, 226, 226, 1);
        background-color: rgba(255, 255, 255, 1);
        margin-top: 80px;
        width: 600px;
        justify-content: center;
        align-items: center;

        .wrap2 {
            z-index: auto;
            width: 520px;
            height: 44px;
            justify-content: space-between;

            .info3 {
                z-index: 57;
                width: 500px;
                height: 40px;
                display: block;
                overflow-wrap: break-word;
                color: rgba(204, 204, 204, 1);
                font-size: 28px;
                white-space: nowrap;
                line-height: 40px;
                text-align: center;
                margin-top: 2px;
            }

            .info4 {
                z-index: 58;
                width: 160px;
                height: 44px;
                display: block;
                overflow-wrap: break-word;
                color: rgba(1, 159, 228, 1);
                font-size: 32px;
                font-family: PingFangSC-Semibold;
                white-space: nowrap;
                line-height: 44px;
                text-align: center;
            }
        }
    }

    .layer4 {
        z-index: 60;
        height: 88px;
        border-radius: 44px;
        border: 2px solid rgba(226, 226, 226, 1);
        background-color: rgba(255, 255, 255, 1);
        margin-top: 60px;
        width: 600px;
        justify-content: center;
        align-items: flex-start;
        padding-left: 38px;

        .word3 {
            z-index: 61;
            width: 500px;
            height: 40px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(204, 204, 204, 1);
            font-size: 28px;
            white-space: nowrap;
            line-height: 40px;
            text-align: center;
        }
    }

    .layer5 {
        z-index: 63;
        height: 88px;
        border-radius: 44px;
        background-color: rgba(1, 159, 228, 1);
        margin-top: 200px;
        width: 600px;
        justify-content: center;
        align-items: center;

        .word4 {
            z-index: 64;
            width: 64px;
            height: 44px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 32px;
            font-family: PingFangSC-Semibold;
            white-space: nowrap;
            line-height: 44px;
            text-align: center;
        }
    }

    .word5 {
        z-index: 50;
        width: 476px;
        height: 40px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: center;
        align-self: center;
        margin-top: 40px;
    }
}

.layer2 {
    z-index: auto;
    width: 512px;
    height: 66px;
    margin-left: 46px;
    justify-content: space-between;

    .label1 {
        z-index: 41;
        width: 48px;
        height: 48px;
        margin-top: 10px;
    }

    .word2 {
        z-index: 49;
        width: 384px;
        height: 66px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 48px;
        font-family: PingFangSC-Semibold;
        white-space: nowrap;
        line-height: 66px;
        text-align: center;
    }

    .label2 {
        z-index: 45;
        width: 48px;
        height: 48px;
        margin-top: 10px;
    }
}

.label1 {
    z-index: 41;
    width: 48px;
    height: 48px;
    margin-top: 10px;
}

.word2 {
    z-index: 49;
    width: 384px;
    height: 66px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 48px;
    font-family: PingFangSC-Semibold;
    white-space: nowrap;
    line-height: 66px;
    text-align: center;
}

.label2 {
    z-index: 45;
    width: 48px;
    height: 48px;
    margin-top: 10px;
}

.layer3 {
    z-index: 56;
    height: 88px;
    border-radius: 44px;
    border: 2px solid rgba(226, 226, 226, 1);
    background-color: rgba(255, 255, 255, 1);
    margin-top: 80px;
    width: 600px;
    justify-content: center;
    align-items: center;

    .wrap2 {
        z-index: auto;
        width: 520px;
        height: 44px;
        justify-content: space-between;

        .info3 {
            z-index: 57;
            width: 168px;
            height: 40px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(204, 204, 204, 1);
            font-size: 28px;
            white-space: nowrap;
            line-height: 40px;
            text-align: center;
            margin-top: 2px;
        }

        .info4 {
            z-index: 58;
            width: 160px;
            height: 44px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(1, 159, 228, 1);
            font-size: 32px;
            font-family: PingFangSC-Semibold;
            white-space: nowrap;
            line-height: 44px;
            text-align: center;
        }
    }
}

.wrap2 {
    z-index: auto;
    width: 520px;
    height: 44px;
    justify-content: space-between;

    .info3 {
        z-index: 57;
        width: 168px;
        height: 40px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(204, 204, 204, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: center;
        margin-top: 2px;
    }

    .info4 {
        z-index: 58;
        width: 160px;
        height: 44px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(1, 159, 228, 1);
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        white-space: nowrap;
        line-height: 44px;
        text-align: center;
    }
}

.info3 {
    z-index: 57;
    width: 168px;
    height: 40px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(204, 204, 204, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: center;
    margin-top: 2px;
}

.info4 {
    z-index: 58;
    width: 160px;
    height: 44px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(1, 159, 228, 1);
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    white-space: nowrap;
    line-height: 44px;
    text-align: center;
}

.layer4 {
    z-index: 60;
    height: 88px;
    border-radius: 44px;
    border: 2px solid rgba(226, 226, 226, 1);
    background-color: rgba(255, 255, 255, 1);
    margin-top: 60px;
    width: 600px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 38px;

    .word3 {
        z-index: 61;
        width: 168px;
        height: 40px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(204, 204, 204, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: center;
    }
}

.word3 {
    z-index: 61;
    width: 168px;
    height: 40px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(204, 204, 204, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: center;
}

.layer5 {
    z-index: 63;
    height: 88px;
    border-radius: 44px;
    background-color: rgba(1, 159, 228, 1);
    margin-top: 200px;
    width: 600px;
    justify-content: center;
    align-items: center;

    .word4 {
        z-index: 64;
        width: 64px;
        height: 44px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        white-space: nowrap;
        line-height: 44px;
        text-align: center;
    }
}

.word4 {
    z-index: 64;
    width: 64px;
    height: 44px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    white-space: nowrap;
    line-height: 44px;
    text-align: center;
}

.word5 {
    z-index: 50;
    width: 476px;
    height: 40px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: center;
    align-self: center;
    margin-top: 40px;
}
</style>